import { X_DISCO_WEBSITE_HOSTNAME } from "@discovery/sonic-api-ng/lib/config/app-config";
import { getRequest, json } from "@discovery/maestro-http";
import * as RTE from "fp-ts/ReaderTaskEither";
import { pipe } from "fp-ts/function";
export const getRealm = (realmName = "realm") => pipe(RTE.ask(), RTE.chainW(({ hostname, realmServiceConfig }) => json(getRequest(`${realmServiceConfig.realmServiceUrl}/${realmName}-config/${hostname}`, {
    [X_DISCO_WEBSITE_HOSTNAME]: hostname,
}, false))), RTE.map((x) => x));
// TODO: The realm service needs to be hardcoded somehow.
// Decided if this is how we should do it
export const getRealmServiceUrl = () => window.location.href.includes("concert.mercury.dnitv.com")
    ? "https://dev-realmservice.mercury.dnitv.com"
    : "https://prod-realmservice.mercury.dnitv.com";

